import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import { UserMenuComponent } from './user-menu.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BackButtonConfirmationModalModule } from '../back-button-confirmation-modal/back-button-confirmation-modal.module';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    BackButtonConfirmationModalModule
  ],
  declarations: [
    UserMenuComponent,
    ChangePasswordComponent
  ],
  exports: [
    UserMenuComponent
  ]
})

export class UserMenuModule { }